import { render, staticRenderFns } from "./companies-contracts.vue?vue&type=template&id=27fcd5c0"
import script from "./companies-contracts.vue?vue&type=script&lang=js"
export * from "./companies-contracts.vue?vue&type=script&lang=js"
import style0 from "./companies-contracts.vue?vue&type=style&index=0&id=27fcd5c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports